import axios from "axios";
import * as actionType from "../constants/actionTypes";
let qs = require("qs");

/*** GetLoginActivityLogs ***/

export const GetLoginActivityLogsStart = () => {
    return {
        error: null,
        loader: true,
        isAuthenticated: true,
        type: actionType.GetLoginActivityLogs_START,
    };
};
export const GetLoginActivityLogsSuccess = (response) => {
    return {
        error: false,
        loader: false,
        isAuthenticated: response.status === 401 ? false : true,
        type: actionType.GetLoginActivityLogs_SUCCESS,
    };
};
export const GetLoginActivityLogsFail = (error) => {
    return {
        error: error,
        loader: false,
        isAuthenticated: error.status === 401 ? false : true,
        type: actionType.GetLoginActivityLogs_FAIL,
    };
};

export const GetLoginActivityLogs = (page, limit, search, from_date, to_date, action) => {
    const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
    return (dispatch) => {
        dispatch(GetLoginActivityLogsStart());
        const params = {
            page: page,
            limit: limit,
            search: search,
            from_date: from_date,
            to_date: to_date,
        };
        if (action && action !== "ALL") {
            params.action = action;
        }
        return axios({
            method: "get",
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("bss_authtoken")}`,
                country_host: user_info?.country_host,
                school_code: user_info?.school_code,
            },
            url: `${actionType.environment_url}/api/bss-admin/GetLoginActivityLogs`,
            params: params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        })
            .then(function (response) {
                dispatch(GetLoginActivityLogsSuccess(response.data));
                return response.data;
            })
            .catch(function (error) {
                dispatch(GetLoginActivityLogsFail("Something went wrong, Please try again."));
                return error;
            });
    };
};



/*** GetSystemLogs ***/

export const GetSystemLogsStart = () => {
    return {
        error: null,
        loader: true,
        isAuthenticated: true,
        type: actionType.GetSystemLogs_START,
    };
};
export const GetSystemLogsSuccess = (response) => {
    return {
        error: false,
        loader: false,
        isAuthenticated: response.status === 401 ? false : true,
        type: actionType.GetSystemLogs_SUCCESS,
    };
};
export const GetSystemLogsFail = (error) => {
    return {
        error: error,
        loader: false,
        isAuthenticated: error.status === 401 ? false : true,
        type: actionType.GetSystemLogs_FAIL,
    };
};




export const GetSystemLogs = ( page,limit,sort,order,search,id,start_date,end_date ) => {
    console.log("Ewrwetretwtrt",limit);
    const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
    return (dispatch) => {
        dispatch(GetSystemLogsStart());
        return axios({
            method: "get",
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("bss_authtoken")}`,
                country_host: user_info?.country_host ,
                school_code: user_info?.school_code,
            },
            url: `${actionType.environment_url}/api/bss-admin/GetSystemLogs`,
            params: {
                page: page,
                limit: limit,
                sort: sort,
                order: order,
                search: search,
                student_uuid: id,
                start_date: start_date,
                end_date: end_date
            },
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        })
            .then(function (response) {
                dispatch(GetSystemLogsSuccess(response.data));
                return response.data;
            })
            .catch(function (error) {
                dispatch(GetSystemLogsFail("Something went wrong, Please try again."));
                return error;
            });
    };
};

